import React from "react";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router-dom";
import { Avatar, Paper, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import HeightBox from "../components/HeightBox";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { WHITE, EMPLOYEE_BLUE } from "../colors";
import UserActivitiesContainer from "./UserActivitiesContainer";
import { getAge } from "../util/calculations.utils";
import { AFFIDAVIT_FORM, APPLICATION_FORM, LETTER, POLICE_FORM } from "../constants/formTypes";
import { FORM_SUBMIT_ROUTE } from "../routes";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import UserRemarksContainer from "./UserRemarksContainer";
import UserMediaFilesContainer from "./UserMediaFilesContainer";
import UserProfileContainer from "./UserProfileContainer";
import CreateCandidateForm from "./profile/form/index";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));

const Customcontainer = styled(Paper)(({ theme }) => ({
  backgroundColor: WHITE,
  borderRadius: 10,
  paddingTop: 20,
  paddingBottom: 20,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  paddingLeft: 40,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
}));

const CustomButton = styled(Button)(({ theme }) => ({
  paddingLeft: 5,
  height: 50,
  minWidth: 260,
  color: WHITE,
  textTransform: "none",
  fontSize: 18,
  fontWeight: 600,
  borderRadius: 20,
  transition: "box-shadow 0.2s ease-in-out", // added transition
  '&:hover': {
    backgroundColor: '#3A9FE0',
    boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.2)",
    transform: "translateY(-2px)", // move up 2 pixels
  },
}));


const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: 14,
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  height: 42,
  minWidth: 312,
  backgroundColor: WHITE,
  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.05)",
  outline: "none",
  borderRadius: 10,
  border: "0px solid #fff",
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover": {
    border: "0px solid #484850",
  },
  "&:focus-within": {
    border: "0px solid #484850",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    border: "0px solid #484850",
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function SingleUserDetailsContainer(props) {
  const { user } = props;
  const history = useHistory();

  const [activityType, setActivityType] = React.useState("");
  const [valueTab, setValueTab] = React.useState(0);

  const handleActivityTabChange = (event, newValue) => {
    setValueTab(newValue);
  };

  const handleChange = (event) => {
    setActivityType(event.target.value);
  };
  
  return (
    <div>
      <HeightBox height={20} />
      <Stack direction="row" spacing={5}>
        <div>
          <Chip size="small" color="primary" label="Customer" />
          <Typography fontSize={18} fontWeight={500} color="#999999">
            {user?.Role?.name}
          </Typography>
          <HeightBox height={10} />
          <Container elevation={0} style={{ width: 226, height: 192 }}>
            <Avatar
              sx={{ width: 130, height: 130 }}
              src={
                user?.imagePath ||
                user?.passport_size_image ||
                user?.full_size_image ||
                "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
              }
            />
          </Container>
        </div>
        <div>
          <Typography fontSize={18} fontWeight={700}>
            Personal Details
          </Typography>
          <HeightBox height={10} />
          <Customcontainer style={{ width: 500, height: 192 }}>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Name : </CustomTypography>
              <CustomTypography>{user?.name || user?.full_name}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Bithday : </CustomTypography>
              <CustomTypography>{user?.dob}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Address : </CustomTypography>
              <CustomTypography>{user?.address}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Age : </CustomTypography>
              <CustomTypography>{getAge(user?.dob)}</CustomTypography>
            </Stack>
            <Stack direction="row" spacing={2}>
              <CustomTypography>Note : </CustomTypography>
              <CustomTypography>{user?.note}</CustomTypography>
            </Stack>
          </Customcontainer>
        </div>
        {user?.reg_number !== undefined ? (
          <div>
            <Stack direction="column" spacing={1}>
          
            
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE }}
                onClick={() => history.push(`${FORM_SUBMIT_ROUTE}?type=${APPLICATION_FORM}&customer=${user.id}`)}
              >
                Application Form
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE }}
                onClick={() => history.push(`${FORM_SUBMIT_ROUTE}?type=${POLICE_FORM}&customer=${user.id}`)}
              >
                Police Report
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE }}
                onClick={() => history.push(`${FORM_SUBMIT_ROUTE}?type=${AFFIDAVIT_FORM}&customer=${user.id}`)}
              >
                Affidavit
              </CustomButton>
              <CustomButton
                style={{ backgroundColor: EMPLOYEE_BLUE }}
                onClick={() => history.push(`${FORM_SUBMIT_ROUTE}?type=${LETTER}&customer=${user.id}`)}
              >
                Letter
              </CustomButton>
            </Stack>
          </div>
        ) : null}
      </Stack>
      <HeightBox height={20} />

      <HeightBox height={20} />
      <Box sx={{ width: "100%", backgroundColor: WHITE, opacity: 1, borderRadius: 4 }}>
        <Box sx={{ borderBottom: 0 }}>
          <Tabs
            value={valueTab}
            onChange={handleActivityTabChange}
            aria-label="basic tabs example"
            sx={{
              backgroundColor: WHITE,
              borderRadius: 2,
            }}
          >
            <Tab label="Activities" {...a11yProps(0)} />
            <Tab label="Remarks" {...a11yProps(1)} />
            <Tab label="Media Files" {...a11yProps(2)} />
            <Tab label="Profile" {...a11yProps(3)} />
          </Tabs>
        </Box>
        <TabPanel value={valueTab} index={0}>
          <Stack direction="row" spacing={5}>
            <div>
              <HeightBox height={5} />
              <Typography fontSize={18} fontWeight={700}>
                Activities
              </Typography>
            </div>

            <CustomSelect
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              onChange={handleChange}
              defaultValue="All"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value={APPLICATION_FORM}>Application form</MenuItem>
              <MenuItem value={POLICE_FORM}>Police form</MenuItem>
              <MenuItem value={AFFIDAVIT_FORM}>Affidavit form</MenuItem>
            </CustomSelect>
          </Stack>
          <HeightBox height={20} />
          <UserActivitiesContainer userId={user.id} activityType={activityType} userRole={props.userRole} />
        </TabPanel>
        <TabPanel value={valueTab} index={1}>
          <UserRemarksContainer userId={user.id} activityType={activityType} userRole={props.userRole} />
        </TabPanel>
        <TabPanel value={valueTab} index={2}>
          <UserMediaFilesContainer userId={user.id} activityType={activityType} userRole={props.userRole} />
        </TabPanel>
        <TabPanel value={valueTab} index={3}>
            <CreateCandidateForm/>
        </TabPanel>

      </Box>
    </div>
  );
}
